import { FormattedMessage } from 'react-intl';

const prefix = 'accessDeniedPage';
export function AccessDeniedPage() {
  const header = <FormattedMessage id={`${prefix}.errorMessage`} defaultMessage="Access Denied" />;
  const subheader = <FormattedMessage id={`${prefix}.errorDescription`} defaultMessage="Error" />;
  const image = '/no-parking-zenner.png';

  return (
    <div className="view-error-page">
      <div className="ui hidden divider"></div>
      <div className="custom-header mark">{header}</div>
      <div className="description">
        <p> {subheader}</p>
      </div>
      <div className="content">
        <div className="center aligned custom-icon">
          <img className="ui centered huge image error-image" src={image} alt="unlink" />
        </div>
      </div>
    </div>
  );
}
